function slideInstaFeed() {
  setTimeout(function () {
    $(".image-carousel").owlCarousel({
      loop: !1,
      margin: 10,
      responsiveClass: !0,
      dots: !1,
      itemElement: "instafeed-container",
      responsive: { 0: { items: 3, nav: !1 }, 640: { items: 4, nav: !1 } },
    });
  }, 600);
}
var instafeedAppEssa = (function e() {
  let t = "instafeed.nfcube.com";
  var i,
    s,
    a,
    o,
    n,
    r,
    l = (function () {
      function e(e) {
        var i, s;
        for (i in ((this.options = {
          target: "insta-feed-essa",
          feedLoaded: !1,
          account: "",
          hash: "",
          forceUpdate: !1,
          picturesLoaded: 0,
          slider: !0,
          sliderPage: 1,
          admin: window.location.hostname === t,
          title: "",
          columns: 5,
        }),
        e))
          (s = e[i]), (this.options[i] = s);
      }
      return (
        (e.prototype.run = function (e) {
          if (
            ((t = this.options.target),
            (t = document.getElementById(t)),
            "" === this.options.accessToken && 4 === this.options.apiVersion)
          )
            return (
              (t.innerHTML =
                "<div class='instafeed-container' style='width:25%;padding-top:25%;'><img class='js-lazy-image' style='width:98%;height:98%;' src='//instafeed.nfcube.com/assets/img/pixel.gif' /></div></div><div class='instafeed-container' style='width:25%;padding-top:25%;'><img class='js-lazy-image' style='width:98%;height:98%;' src='//instafeed.nfcube.com/assets/img/pixel.gif' /></div></div><div class='instafeed-container' style='width:25%;padding-top:25%;'><img class='js-lazy-image' style='width:98%;height:98%;' src='//instafeed.nfcube.com/assets/img/pixel.gif' /></div></div><div class='instafeed-container' style='width:25%;padding-top:25%;'><img class='js-lazy-image' style='width:98%;height:98%;' src='//instafeed.nfcube.com/assets/img/pixel.gif' /></div></div>"),
              (t.innerHTML +=
                "<div><em><b>Connect your Instagram account to see your feed</b></em></div>"),
              !1
            );
          t.innerHTML =
            "<img src='//instafeed.nfcube.com/assets/img/loader.gif' style='position:relative;height:11px;width:16px;' alt='loading bar' />";
          var t,
            i = this;
          let s = new XMLHttpRequest();
          return (
            s.open("GET", e || this._buildUrl(), !0),
            (s.onreadystatechange = function () {
              if (4 === s.readyState) {
                var e = s.status;
                0 === e || (200 >= e && 400 > e)
                  ? i.parse(JSON.parse(s.responseText))
                  : console.log("error");
              }
              slideInstaFeed();
            }),
            s.send(),
            !0
          );
        }),
        (e.prototype.parse = function (e) {
          var i, s, a, o, n, r, l, g, f, m, v, _, b, y, w, x, E, j, I;
          if (
            ((j = this.options.target),
            (j = document.getElementById(j)),
            "object" != typeof e)
          )
            throw Error("Invalid JSON response");
          if (200 !== e.meta.code)
            throw (
              ((j.innerHTML = this.options.admin
                ? "<em>" + e.meta.error_message + "</em>"
                : ""),
              Error("Error from API: " + e.meta.error_message))
            );
          if (e.meta.error_message)
            throw (
              ((j.innerHTML = "<em>" + e.meta.error_message + "</em>"),
              Error("Error from API: " + e.meta.error_message))
            );
          if (0 === e.data.length)
            throw (
              ((j.innerHTML =
                "<em>No images were returned from this Instagram account</em>"),
              Error("No images were returned from Instagram"))
            );
          if (
            (null !== this.options.success &&
              "function" == typeof this.options.success &&
              this.options.success.call(this, e),
            "undefined" != typeof document && null !== document)
          ) {
            (_ = e.data),
              (n = document.createDocumentFragment()),
              (r = ""),
              (m = ""),
              (b = ""),
              (I = document.createElement("div"));
            var L =
                (j.clientWidth / this.options.columns) *
                window.devicePixelRatio,
              k = "standard_resolution",
              S = this.options.limit,
              M = parseFloat(100 / this.options.columns).toFixed(6),
              A = parseInt(100 - this.options.space);
            u() &&
              d(this.options.charge) &&
              ((L =
                (j.clientWidth / this.options.columnsMobile) *
                window.devicePixelRatio),
              (M = parseFloat(100 / this.options.columnsMobile).toFixed(6)),
              (S = this.options.limitMobile)),
              150 >= L ? (k = "thumbnail") : 320 >= L && (k = "low_resolution");
            var C = "",
              T = "";
            d(this.options.charge) &&
              0 < parseInt(this.options.likes) &&
              4 !== parseInt(this.options.apiVersion) &&
              ((C =
                "<div class='likes'><span style='padding-right: 5px;'><svg width='10' height='10' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path d='M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z' fill='white'></path></svg></span>{{likes}}<!--<span style='width: 10px;padding-right: 5px;padding-left: 5px;'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512'><path d='M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z' fill='white'></path></svg></span> {{comments}}--></div>"),
              (T =
                "<span><span style='padding-right: 5px;'><svg width='10' height='10' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path d='M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z' fill='grey'></path></svg> {{likes}}</span> <!--<span>&#10078; {{comments}}</span>-->"));
            var P =
                "<div style='width:" +
                A +
                "%;height:" +
                A +
                "%;' class='instafeed-overlay {{video}}'>" +
                C +
                "</div>",
              O =
                "<div class='instafeed-container' style='width:" +
                M +
                "%;padding-top:" +
                M +
                "%;'><img class='js-lazy-image' style='width:" +
                A +
                "%;height:" +
                A +
                "%;' src='//" +
                t +
                "/assets/img/pixel.gif' data-src='{{image}}' alt='{{captionAlt}} on Instagram' />" +
                P +
                "</div>",
              N = "";
            for (
              1 === parseInt(this.options.openIg)
                ? (O =
                    "<a href='{{link}}' target='_blank' rel='noopener'>" +
                    O +
                    "</a>")
                : 2 === parseInt(this.options.openIg)
                ? (O = this.options.admin
                    ? "<a href='" +
                      this.options.shopOrigin +
                      "/collections/all' target='_blank' rel='noopener'>" +
                      O +
                      "</a>"
                    : "<a href='//" +
                      window.location.hostname +
                      "/collections/all'>" +
                      O +
                      "</a>")
                : 3 === parseInt(this.options.openIg) &&
                  (this.options.admin &&
                    (N =
                      "<div class='products-tagging'><object><a href='#{{id}}-" +
                      this.options.target +
                      "' id='search' data-picture-id='{{fullId}}'><b><button class='primary'>Tag Product</button></b></a></object></div><em id='tagging-{{fullId}}'></em>"),
                  (O =
                    "<a href='#{{id}}-" +
                    this.options.target +
                    "'>" +
                    O +
                    "</a><div class='instafeed-lightbox' id='{{id}}-" +
                    this.options.target +
                    "'><div class='lightbox-instagram' role='dialog' aria-labelledby='{{id}}-" +
                    this.options.target +
                    "' aria-modal='true'><div class='instafeed-post-image'>{{imageFullHtml}}</div><div class='description'><div class='instafeed-header'><div class='close-button'><a style='height:25px;width:25px;display:block!important;position:relative;' aria-label='close button' href='#_' id='close-button-url'></a></div><object><a href='https://www.instagram.com/{{username}}' target='_blank' rel='noopener' tabindex='-1'><img src='//" +
                    t +
                    "/assets/img/instagram-logo.png' data-feed-id='" +
                    this.options.target +
                    "' class='profile-picture js-lazy-image' data-src='{{userPicture}}' alt='instagram profile picture' /></a></object><object class='name-section'><a class='fullname' href='https://www.instagram.com/{{username}}/' target='_blank' rel='noopener'><div class='fullname instafeed-text' data-feed-id='" +
                    this.options.target +
                    "'>{{fullName}}</div><div class='username'>@{{username}}</div></a></object></div><hr><div class='box-content'><div class='sub-header'><div class='post-engagement'>" +
                    T +
                    "</div><div class='arrows'><object><a href='#{{minusId}}-" +
                    this.options.target +
                    "'><img src='//" +
                    t +
                    "/assets/img/pixel.gif' alt='previous image' /></a></object><object><a href='#{{plusId}}-" +
                    this.options.target +
                    "'><img src='//" +
                    t +
                    "/assets/img/pixel.gif' alt='next image' /></a></object></div></div>" +
                    N +
                    " {{taggedProduct}}<div class='instafeed-caption'>{{caption}}</div><div class='post-date'>{{date}} • <object><a href='{{link}}' target='_blank' rel='noopener' class='follow'>View on Instagram</a></object></div></div></div></div></div>")),
                l = 0,
                w = _.length;
              l < w;
              l++
            ) {
              var z = "";
              if ("object" != typeof (f = (g = _[l]).images[k]))
                throw Error((o = "No image found for resolution: " + k + "."));
              if (
                g.hasOwnProperty("tagged_products") &&
                0 < g.tagged_products.length &&
                d(this.options.charge)
              ) {
                var q = this.options.admin,
                  B = this.options.shopOrigin,
                  H = this.options.target;
                g.tagged_products.forEach(function (e) {
                  q
                    ? ((taggedProductUrl =
                        "<object class='product-title'><a href='https://" +
                        B +
                        "/products/" +
                        e.handle +
                        "/' target='_blank' rel='noopener'>" +
                        e.title +
                        "</a><a href='#{{id}}-" +
                        H +
                        "' id='delete-product' data-picture-id='{{fullId}}' data-tagging-id='" +
                        e.id +
                        "'><div class='tagged-buy-button'>Delete</div></a></object>"),
                      (productImageUrl =
                        "<object><a href='https://" +
                        B +
                        "/products/" +
                        e.handle +
                        "/' target='_blank' rel='noopener'><img class='js-lazy-image' src='https://" +
                        t +
                        "/assets/img/pixel.gif' data-src='" +
                        e.image +
                        "' alt='product image' /></a></object>"))
                    : q ||
                      ((taggedProductUrl =
                        "<object class='product-title'><a href='//" +
                        window.location.hostname +
                        "/products/" +
                        e.handle +
                        "/'>" +
                        e.title +
                        "</a><a href='//" +
                        window.location.hostname +
                        "/products/" +
                        e.handle +
                        "'><button class='tagged-buy-button' tabindex='-1'>Shop Now</button></a></object>"),
                      (productImageUrl =
                        "<object><a href='//" +
                        window.location.hostname +
                        "/products/" +
                        e.handle +
                        "/'><img class='js-lazy-image' src='https://" +
                        t +
                        "/assets/img/pixel.gif' data-src='" +
                        e.image +
                        "' alt='product image' /></a></object>")),
                    (z +=
                      "<div class='tagged-products' id='{{fullId}}-" +
                      e.id +
                      "'>" +
                      productImageUrl +
                      " " +
                      taggedProductUrl +
                      "</div>");
                });
              }
              var F = "";
              "video" === g.type && g.hasOwnProperty("videos")
                ? ((F = "instafeed-video"),
                  (imageFullHtml =
                    '<video controls playsinline muted id="video-{{id}}-instafeed" preload="none" src="' +
                    g.videos.standard_resolution.url +
                    '"</video>'))
                : (imageFullHtml =
                    "<a href='#_' tabindex='-1'><img class='js-lazy-image' src='//instafeed.nfcube.com/assets/img/pixel.gif' data-src='" +
                    g.images.standard_resolution.url +
                    "' alt='{{captionAlt}}'></a>"),
                (v = f.url),
                this.options.picturesLoaded++;
              var Y =
                  1 === this.options.picturesLoaded
                    ? S
                    : this.options.picturesLoaded - 1,
                U =
                  this.options.picturesLoaded === S
                    ? 1
                    : this.options.picturesLoaded + 1;
              if (0 < this.options.slider) {
                var V =
                    u() && d(this.options.charge)
                      ? this.options.columnsMobile
                      : this.options.columns,
                  D = Math.ceil(this.options.picturesLoaded / V);
                let R = D * V,
                  X = (D - 1) * V + 1;
                var Y =
                    this.options.picturesLoaded === X
                      ? R
                      : this.options.picturesLoaded - 1,
                  U =
                    this.options.picturesLoaded === R
                      ? X
                      : this.options.picturesLoaded + 1;
              }
              if (
                ((m = this._makeTemplate(O, {
                  model: g,
                  id: this.options.picturesLoaded,
                  fullId: g.id,
                  minusId: Y,
                  plusId: U,
                  link: g.link,
                  image: v,
                  video: F,
                  slider: this.options.slider ? "display:none;" : "",
                  username: g.user.username,
                  fullName: g.user.full_name,
                  userPicture: g.user.profile_picture,
                  imageFullHtml: imageFullHtml,
                  taggedProduct: z,
                  date: h(g.created_time),
                  caption: c(this._getObjectProperty(g, "caption.text")),
                  captionAlt: c(
                    this._getObjectProperty(g, "caption.text").substring(0, 100)
                  ),
                  likes: p(g.likes.count, 1),
                  comments: p(g.comments.count, 1),
                  location: this._getObjectProperty(g, "location.name"),
                })),
                0 < this.options.slider)
              ) {
                let G = "";
                1 === this.options.picturesLoaded &&
                  (G = "<div style='position:relative;'>"),
                  (m =
                    G +
                    '<span class="slide-page" data-slide-page="' +
                    D +
                    '" >' +
                    m +
                    "</span>");
              }
              if (
                ((r += m),
                this.options.picturesLoaded >= S ||
                  e.data.length === this.options.picturesLoaded)
              ) {
                0 < this.options.slider &&
                  e.data.length > V &&
                  ((r +=
                    '<div class="slider-arrow" onclick="instafeedSlide(1)" style="right:-15px;">&#10095;</div>'),
                  (r +=
                    '<div class="slider-arrow" onclick="instafeedSlide(-1)" style="left:-15px;">&#10094;</div>'),
                  (r += "</div>"));
                break;
              }
            }
            for (
              I.innerHTML = r, a = [], s = 0, i = I.childNodes.length;
              s < i;

            )
              a.push(I.childNodes[s]), (s += 1);
            for (y = 0, x = a.length; y < x; y++) (E = a[y]), n.appendChild(E);
            if (((j.innerHTML = ""), 0 < this.options.title.length)) {
              var W = document.createElement("h2");
              (W.innerHTML = this.options.title),
                j.insertBefore(W, j.firstChild);
            }
            j.appendChild(n);
          }
          return (
            (function e() {
              function t(e) {
                var t;
                let i = e.dataset.src;
                return i.includes("https://")
                  ? ((t = i),
                    new Promise((e, i) => {
                      let s = new Image();
                      (s.src = t), (s.onload = e), (s.onerror = i);
                    }))
                      .then(() => {
                        var t, s;
                        (t = e),
                          (s = i),
                          t.classList.add("js-lazy-image--handled"),
                          (t.src = s);
                      })
                      .catch((e) => {
                        console.log(e);
                      })
                  : void 0;
              }
              let i = document.querySelectorAll(".js-lazy-image"),
                s,
                a = i.length;
              if ("IntersectionObserver" in window) {
                s = new IntersectionObserver(
                  function e(i) {
                    0 === a && s.disconnect();
                    for (let o, n = 0; n < i.length; n++)
                      0 < (o = i[n]).intersectionRatio &&
                        (a--, s.unobserve(o.target), t(o.target));
                  },
                  { rootMargin: "100px 0px", threshold: 0.01 }
                );
                for (let o, n = 0; n < i.length; n++)
                  (o = i[n]).classList.contains("js-lazy-image--handled") ||
                    s.observe(o);
              } else
                !(function (e) {
                  for (let i, s = 0; s < e.length; s++) t((i = e[s]));
                })(i);
            })(),
            0 < this.options.slider && instafeedSlide(0),
            !0
          );
        }),
        (e.prototype._buildUrl = function () {
          var e, t;
          if (
            ((t = this.options.forceUpdate ? 1 : 0),
            4 === this.options.apiVersion)
          ) {
            var i =
              this.options.limitMobile > this.options.limit
                ? this.options.limitMobile
                : this.options.limit;
            e =
              "https://instafeed.nfcube.com/feed/v4?charge=" +
              this.options.charge +
              "&fu=" +
              t +
              "&limit=" +
              i +
              "&account=" +
              this.options.shopOrigin +
              "&fid=" +
              this.options.feedId +
              "&hash=" +
              this.options.hash;
          } else if (5 === this.options.apiVersion) {
            var i =
              this.options.limitMobile > this.options.limit
                ? this.options.limitMobile
                : this.options.limit;
            e =
              "https://instafeed.nfcube.com/feed/v5?charge=" +
              this.options.charge +
              "&fu=" +
              t +
              "&limit=" +
              i +
              "&account=" +
              this.options.shopOrigin +
              "&fid=" +
              this.options.feedId +
              "&hash=" +
              this.options.hash;
          }
          return e;
        }),
        (e.prototype._makeTemplate = function (e, t) {
          var i, s, a, o, n;
          for (s = /(?:\{{2})([\w\[\]\.]+)(?:\}{2})/, i = e; s.test(i); )
            (o = i.match(s)[1]),
              (n = null === (a = this._getObjectProperty(t, o)) ? "" : a),
              (i = i.replace(s, function () {
                return "" + n;
              }));
          return i;
        }),
        (e.prototype._getObjectProperty = function (e, t) {
          var i, s;
          for (s = (t = t.replace(/\[(\w+)\]/g, ".$1")).split("."); s.length; )
            if (((i = s.shift()), null === e || !(i in e))) return null;
            else e = e[i];
          return e;
        }),
        e
      );
    })();
  function d(e) {
    return 0 < parseInt(e);
  }
  function c(e) {
    return (
      e &&
        (e = e
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#039;")),
      e
    );
  }
  function p(e, t) {
    for (
      var i, s = ["k", "M", "G", "T", "P", "E", "Z", "Y"], a = s.length - 1;
      0 <= a;
      a--
    )
      if (e <= -(i = Math.pow(1e3, a + 1)) || e >= i)
        return +(e / i).toFixed(t) + s[a];
    return e;
  }
  function h(e) {
    return new Date(1e3 * e)
      .toLocaleDateString(navigator.language, { month: "long", day: "numeric" })
      .toUpperCase();
  }
  function u() {
    return window.matchMedia("only screen and (max-width: 760px)").matches;
  }
  return (
    (i = this),
    (s = function () {
      return l;
    }),
    "function" == typeof define && define.amd
      ? define([], s)
      : "object" == typeof module && module.exports
      ? ((module.exports = s()), module.exports)
      : ((i.Instafeed = s()), i.Instafeed),
    (function () {
      if (
        null !== document.currentScript &&
        !document.currentScript.src.includes(t)
      )
        return !1;
      var e = document.createElement("link");
      (e.href = "https://instafeed.nfcube.com/cdn/instafeed-4.6.1.css"),
        (e.type = "text/css"),
        (e.rel = "stylesheet"),
        (e.media = "screen,print"),
        document.getElementsByTagName("head")[0].appendChild(e);
    })(),
    (o = ""),
    (n = !1),
    (r = document.getElementById("PageContainer")),
    (window.instafeedSlidePage = 1),
    (window.instafeedSlide = function (e = 0) {
      instafeedSlidePage = parseInt(instafeedSlidePage) + parseInt(e);
      let t = document.body.querySelectorAll("#insta-feed-essa");
      0 === parseInt(t.length) &&
        (t = document.body.querySelectorAll(".instafeed-shopify")),
        (t[0].style.padding = "0 20px 0 20px");
      var i = document.body.querySelectorAll(".slide-page"),
        s = 0;
      for (let a = 0; a < i.length; a++) {
        var o = i[a].getAttribute("data-slide-page");
        s < o && (s = o);
      }
      0 >= instafeedSlidePage && (instafeedSlidePage = s),
        instafeedSlidePage > s && (instafeedSlidePage = 1);
      let n = document.body.querySelectorAll(
        '[data-slide-page="' + instafeedSlidePage + '"]'
      );
      i.forEach((e) => {
        e.style.display = "none";
      }),
        n.forEach((e) => {
          e.style.display = "initial";
        });
    }),
    window.addEventListener(
      "hashchange",
      function e() {
        var t = location.hash.split("!").pop().replace("/", "");
        if (
          ((i = document.getElementById(
            "video-" +
              o.substring(
                o.lastIndexOf("#") + 1,
                o.lastIndexOf("-insta-feed")
              ) +
              "-instafeed"
          )),
          (a = document.getElementById(
            "video-" +
              t.substring(
                t.lastIndexOf("#") + 1,
                t.lastIndexOf("-insta-feed")
              ) +
              "-instafeed"
          )),
          i &&
            (i.pause(),
            (i.onplay = function () {
              "#_" === t && i.pause();
            })),
          (o = t),
          "#_" === t || 0 === t.length)
        )
          (document.body.style.overflowY = "visible"),
            r &&
              (!0 === n && (r.style.webkitTransform = "translate3d(0, 0, 0)"),
              (r.style.overflowY = "visible"));
        else if (t.includes("-feed")) {
          function i(e) {
            ("Tab" === e.key || 9 === e.keyCode) &&
              (e.shiftKey
                ? document.activeElement === l &&
                  (c.focus(), e.preventDefault())
                : document.activeElement === c &&
                  (l.focus(), e.preventDefault()));
          }
          let s = document.querySelector("[id='" + t.substring(1) + "']"),
            l = s.querySelectorAll("#close-button-url, .follow")[0],
            d = s.querySelectorAll("#close-button-url, .follow"),
            c = d[d.length - 1];
          if (
            (document.removeEventListener("keydown", i),
            document.addEventListener("keydown", i),
            a && a.play(),
            r)
          ) {
            let p = getComputedStyle(r);
            "none" !== p.webkitTransform &&
              ((r.style.webkitTransform = "initial"),
              (n = !0),
              document.getElementById("insta-feed-essa").scrollIntoView()),
              (r.style.overflowY = "hidden");
          }
          document.body.style.overflowY = "hidden";
        }
      },
      !1
    ),
    (function (e, t) {
      "use strict";
      function i(e, i, s) {
        for (; e && e !== t.documentElement; ) {
          var a = e.getAttribute(i);
          if (a) return a;
          e = e.parentNode;
        }
        return s;
      }
      "function" != typeof e.CustomEvent &&
        ((e.CustomEvent = function (e, i) {
          i = i || { bubbles: !1, cancelable: !1, detail: void 0 };
          var s = t.createEvent("CustomEvent");
          return s.initCustomEvent(e, i.bubbles, i.cancelable, i.detail), s;
        }),
        (e.CustomEvent.prototype = e.Event.prototype)),
        t.addEventListener(
          "touchstart",
          function (e) {
            "true" === e.target.getAttribute("data-swipe-ignore") ||
              ((l = e.target),
              (r = Date.now()),
              (s = e.touches[0].clientX),
              (a = e.touches[0].clientY),
              (o = 0),
              (n = 0));
          },
          !1
        ),
        t.addEventListener(
          "touchmove",
          function (e) {
            if (s && a) {
              var t = e.touches[0].clientX,
                i = e.touches[0].clientY;
              (o = s - t), (n = a - i);
            }
          },
          !1
        ),
        t.addEventListener(
          "touchend",
          function (e) {
            if (l === e.target) {
              var t = parseInt(i(l, "data-swipe-threshold", "20"), 10),
                d = parseInt(i(l, "data-swipe-timeout", "500"), 10),
                c = Date.now() - r,
                p = "",
                h = e.changedTouches || e.touches || [];
              if (
                (Math.abs(o) > Math.abs(n)
                  ? Math.abs(o) > t &&
                    c < d &&
                    (p = 0 < o ? "swiped-left" : "swiped-right")
                  : Math.abs(n) > t &&
                    c < d &&
                    (p = 0 < n ? "swiped-up" : "swiped-down"),
                "" != p)
              ) {
                var u = {
                  dir: p.replace(/swiped-/, ""),
                  xStart: parseInt(s, 10),
                  xEnd: parseInt((h[0] || {}).clientX || -1, 10),
                  yStart: parseInt(a, 10),
                  yEnd: parseInt((h[0] || {}).clientY || -1, 10),
                };
                l.dispatchEvent(
                  new CustomEvent("swiped", {
                    bubbles: !0,
                    cancelable: !0,
                    detail: u,
                  })
                ),
                  l.dispatchEvent(
                    new CustomEvent(p, {
                      bubbles: !0,
                      cancelable: !0,
                      detail: u,
                    })
                  );
              }
              (s = null), (a = null), (r = null);
            }
          },
          !1
        );
      var s = null,
        a = null,
        o = null,
        n = null,
        r = null,
        l = null;
    })(window, document),
    null !== document.getElementById("insta-feed-essa") &&
      new l({
        account: "",
        hash: "c7ab603fa301b19aef0615de40be64ac",
        apiVersion: 4,
        shopOrigin: "essaworld-pty.myshopify.com",
        title: "",
        openIg: 1,
        space: 10,
        likes: 1,
        slider: 0,
        filter: "",
        public: 0,
        columns: 4,
        feedId: 0,
        columnsMobile: 0,
        limit: 4,
        limitMobile: 0,
        charge: "0",
      }).run(),
    e
  );
})();
instafeedAppEssa(),
  window.addEventListener("load", function () {
    var e = document.querySelector(".jsShowNewsletter"),
      t = document.querySelector(".NewsletterPopup");
    e &&
      e.addEventListener("click", function () {
        if (
          t &&
          t.hasAttribute("aria-hidden") &&
          "true" == t.getAttribute("aria-hidden")
        )
          return t.setAttribute("aria-hidden", "false"), !1;
        t.setAttribute("aria-hidden", "true");
      });
  });
const targetNode = document.querySelector("body"),
  config = { attributes: !0, childList: !0, subtree: !0 },
  callback = function (e, t) {
    let siteLanguage = document.querySelector("html").getAttribute("lang");
    let price;
    for (let i of e) {
      if (i.previousSibling?.className === "doubly-float") {
        let s = i.previousSibling.querySelector(".currency-switcher"),
          a = document.querySelector("html").getAttribute("lang");
        "hu" === a && ((s.value = "HUF"), s.dispatchEvent(new Event("change"))),
          "hu" !== a &&
            ((s.value = "EUR"), s.dispatchEvent(new Event("change")));
      }
      if ("money" === i.target.className) {
        let o = i.target,
          n = i.target.textContent,
          r = document.querySelector("html").getAttribute("lang");
        "hu" === r &&
          o.textContent.includes(",00") &&
          (console.log("modify hu"), (o.textContent = n.replace(",00", "")));
      }

      if (i.target.classList.contains("rc_widget__option--onetime")) {
        if (siteLanguage === "hu") {
          i.target.children[1].querySelector('.rc-option__text').textContent = 'Egyszeri vásárlás';
        }

        i.target.children[1].querySelector('[data-price-onetime]').innerHTML = '<span class="money">' + i.target.children[1].querySelector('[data-price-onetime]').textContent  + '</span>';
        document.querySelector(".currency-switcher").dispatchEvent(new Event("change"));
      }

      if (i.target.classList.contains("rc_widget__option--subsave")) {
        if (siteLanguage === "hu") {
          i.target.children[1].querySelector('.rc-option__text').textContent = 'Előfizetés és megtakarítás';
        }

        i.target.children[1].querySelector('[data-price-subsave]').innerHTML = '<span class="money">' + i.target.children[1].querySelector('[data-price-subsave]').textContent  + '</span>';
        document.querySelector(".currency-switcher").dispatchEvent(new Event("change"));
      }

      if (i.target.classList.contains("rc-selling-plans")) {
        console.log(i);
        if (siteLanguage === "hu") {
          i.target.children[1].querySelector('option:first-child').textContent = 'Kiszállítás 2 hetente';
          i.target.children[1].querySelector('option:last-child').textContent = 'Kiszállítás 4 hetente';
        }

        if(i.target.childNodes.length === 2) {
          createCustomSelect();
        }

        //createCustomSelect();
      }

      if(i.target.classList.contains("recharge-inner-most-price")) {
        if(i.target.children.length === 0) {
          i.target.innerHTML = '<span class="money">' + i.target.textContent  + '</span>';
        }

        let onetime = document.querySelector('[data-price-onetime]');

        if (onetime && onetime.children.length === 0) {
          onetime.innerHTML = '<span class="money">' + onetime.textContent  + '</span>';
        }

        let subsave = document.querySelector('[data-price-subsave]');

        if (subsave && subsave.children.length === 0) {
          subsave.innerHTML = '<span class="money">' + subsave.textContent  + '</span>';
        }

        document.querySelector(".currency-switcher").dispatchEvent(new Event("change"));
      }
    }
  },
  observer = new MutationObserver(callback);
observer.observe(targetNode, config);

function createCustomSelect() {
  console.log('create');
  let x, i, j, l, ll, selElmnt, a, b, c;
/* Look for any elements with the class "custom-select": */
x = document.getElementsByClassName("rc-selling-plans");
l = x.length;
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  ll = selElmnt.length;
  /* For each element, create a new DIV that will act as the selected item: */
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /* For each element, create a new DIV that will contain the option list: */
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 0; j < ll; j++) {
    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener("click", function(e) {
        /* When an item is clicked, update the original select box,
        and the selected item: */
        let y, i, k, s, h, sl, yl;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        sl = s.length;
        h = this.parentNode.previousSibling;
        for (i = 0; i < sl; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            yl = y.length;
            for (k = 0; k < yl; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function(e) {
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");
  });
}
}

function closeAllSelect(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x, y, i, xl, yl, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener("click", closeAllSelect);